import React from 'react'
import tinycolor from 'tinycolor2'
import { Box, Checkbox, FormControlLabel, FormGroup, Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { updateChartConfig } from '../../../../reducer/chart.reducer'
import { selectOiWidgetSettings } from '../../../../selectors/chart'
import { OiWidgetSettings } from '../../../chartV2/chart.typings'
import ColorSelector from '../../../colorSelector/colorSelector'
import {
    chartSettingsCheckboxColorLabelSx,
    chartSettingsColorRowSx,
    chartSettingsFormGroupSx,
    chartSettingsSectionTitleSx,
} from '../../../chartSettings/chartSettingsLayout'

type Props = {
    viewKey: string
}

const OiSymbolSettings = ({ viewKey }: Props) => {
    const dispatch = useDispatch()
    const oiSettings = useSelector(selectOiWidgetSettings(viewKey))

    const updateSettings = (partial: Partial<OiWidgetSettings>) => {
        dispatch(updateChartConfig({
            viewKey,
            config: {
                oiWidgetSettings: {
                    ...oiSettings,
                    ...partial,
                },
            },
            createIfAbsent: false,
        }))
    }

    const callColor = tinycolor(oiSettings.callColor ?? '#000000')
    const putColor = tinycolor(oiSettings.putColor ?? '#000000')

    return (
        <Box>
            <Typography variant="subtitle1" sx={chartSettingsSectionTitleSx}>
                HISTOGRAMS
            </Typography>
            <FormGroup sx={chartSettingsFormGroupSx}>
                <Box sx={chartSettingsColorRowSx}>
                    <FormControlLabel
                        sx={chartSettingsCheckboxColorLabelSx}
                        control={
                            <Checkbox
                                checked={!!(oiSettings.showCall ?? true)}
                                onChange={(e) => updateSettings({ showCall: e.target.checked })}
                            />
                        }
                        label="Call"
                    />
                    <ColorSelector
                        compact
                        showOnlySwatch
                        color={callColor.toHexString()}
                        opacity={callColor.getAlpha()}
                        onColorChange={(color, transparency) => {
                            const newColor = tinycolor(color).setAlpha(transparency).toHex8String()
                            updateSettings({ callColor: newColor })
                        }}
                    />
                </Box>
                <Box sx={chartSettingsColorRowSx}>
                    <FormControlLabel
                        sx={chartSettingsCheckboxColorLabelSx}
                        control={
                            <Checkbox
                                checked={!!(oiSettings.showPut ?? true)}
                                onChange={(e) => updateSettings({ showPut: e.target.checked })}
                            />
                        }
                        label="Put"
                    />
                    <ColorSelector
                        compact
                        showOnlySwatch
                        color={putColor.toHexString()}
                        opacity={putColor.getAlpha()}
                        onColorChange={(color, transparency) => {
                            const newColor = tinycolor(color).setAlpha(transparency).toHex8String()
                            updateSettings({ putColor: newColor })
                        }}
                    />
                </Box>
            </FormGroup>
        </Box>
    )
}

export default OiSymbolSettings
